/* Notable delivery date and time window (product page + cart).
 * Saves "Delivery date" and "Delivery window" as cart attributes. Holds back checkout buttons until both are set.
 * Today is offered only before the cut-off hour in Nairobi time, and only for windows starting `lead` hours from now. */
(function () {
  var TZ = 'Africa/Nairobi';
  var KEY = 'notable-delivery';
  var attrs = null; // last known cart attributes, null until loaded

  function nowNairobi() {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
    var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
    return { date: o.year + '-' + o.month + '-' + o.day, hour: parseInt(o.hour, 10) % 24 };
  }
  function addDays(iso, n) { var d = new Date(iso + 'T00:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); }
  function pretty(iso) { return new Date(iso + 'T00:00:00Z').toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }); }
  var FEE = 'delivery-fee', cartItems = [];
  function ready() { return !!(attrs && attrs['Delivery date'] && attrs['Delivery window'] && (!document.querySelector('[data-ndw-areas]') || attrs['Delivery area'])); }
  /* the delivery fee is a small hidden product: exactly one line matching the chosen area, and only while the cart holds something else */
  function syncFee() {
    var key = attrs && attrs['Delivery area'];
    var radio = key && document.querySelector('[data-ndw-areas] input[value="' + key.replace(/"/g, '') + '"]');
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var fees = c.items.filter(function (i) { return i.handle === FEE; });
      var others = c.items.length - fees.length;
      var want = others > 0 && radio ? parseInt(radio.dataset.variant, 10) : 0;
      var ok = want ? (fees.length === 1 && fees[0].variant_id === want && fees[0].quantity === 1) : fees.length === 0;
      if (ok) return false;
      var upd = {}; fees.forEach(function (f) { upd[f.key] = 0; });
      var p = fees.length ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) }) : Promise.resolve();
      return p.then(function () { return want ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: want, quantity: 1 }] }) }) : null; }).then(function () { return true; });
    }).catch(function () { return false; });
  }
  function refreshCartView(changed) { if (changed && /^\/cart/.test(location.pathname)) location.reload(); }

  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { attrs = c.attributes || {}; return c; }).catch(function () { attrs = attrs || {}; });
  }
  function remindOn() { var c = document.querySelector('[data-ndw-remind]'); return c ? c.checked : (function () { try { return localStorage.getItem(KEY + '-remind') === '1'; } catch (e) { return false; } })(); }
  function save(date, win) {
    var ar = document.querySelector('[data-ndw-areas] input:checked');
    var body = { attributes: { 'Delivery area': ar ? ar.value : (attrs && attrs['Delivery area']) || '', 'Delivery date': date ? pretty(date) : '', 'Delivery window': win || '', 'Remind me next year': remindOn() ? 'Yes' : '' } };
    if (date) body.attributes['Delivery date (sortable)'] = date;
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (c) { attrs = c.attributes || {}; try { localStorage.setItem(KEY, JSON.stringify({ date: date, win: win })); } catch (e) {} });
  }

  function init(root) {
    if (root.__ndw) return; root.__ndw = true;
    var cutoff = isNaN(parseInt(root.dataset.cutoff, 10)) ? 14 : parseInt(root.dataset.cutoff, 10), lead = parseInt(root.dataset.lead, 10) || 3, days = parseInt(root.dataset.days, 10) || 45;
    var dateEl = root.querySelector('[data-ndw-date]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-ndw-windows] input'));
    var status = root.querySelector('[data-ndw-status]');
    var tg = root.querySelector('[data-ndw-toggle]'), body = root.querySelector('[data-ndw-body]'), sum = root.querySelector('[data-ndw-summary]');
    function setOpen(on) { if (!tg) return; tg.setAttribute('aria-expanded', on ? 'true' : 'false'); body.hidden = !on; }
    root.__ndwOpen = function () { setOpen(true); };
    if (tg) tg.addEventListener('click', function () { setOpen(body.hidden); });
    function summarise() {
      if (!sum) return;
      var a = attrs || {};
      if (ready()) { sum.textContent = (a['Delivery area'] ? a['Delivery area'] + ' · ' : '') + a['Delivery date'] + ' · ' + a['Delivery window']; }
      else { sum.textContent = root.classList.contains('is-missing') ? 'Required to check out: choose area, date and time' : 'Choose area, date and time'; }
    }
    root.__ndwSum = summarise;
    var areas = Array.prototype.slice.call(root.querySelectorAll('[data-ndw-areas] input'));
    var now = nowNairobi();
    function area() { var a = areas.filter(function (x) { return x.checked; })[0]; return a ? a.dataset.key : ''; }
    function leadNow() { return area() === 'NB-DEL-OUT' ? Math.max(lead, 6) : lead; }
    function setMin() {
      var sameDay = area() !== 'NB-DEL-OTH' && now.hour < cutoff;
      dateEl.min = sameDay ? now.date : addDays(now.date, 1); dateEl.max = addDays(now.date, days);
      var noteEl = root.querySelector('[data-ndw-note]');
      if (noteEl) { noteEl.hidden = !(cutoff > 0 && !sameDay); noteEl.textContent = area() === 'NB-DEL-OTH' ? 'Other towns are delivered the next day. The earliest date is tomorrow.' : "Today's same-day slots have closed. The earliest date is tomorrow."; }
      if (dateEl.value && dateEl.value < dateEl.min) dateEl.value = '';
    }
    setMin();

    function say(msg, err) { status.textContent = msg || ''; status.classList.toggle('is-error', !!err); }
    function refreshWindows() {
      var today = dateEl.value === now.date;
      radios.forEach(function (r) {
        var off = today && parseInt(r.dataset.start, 10) < now.hour + leadNow();
        r.disabled = off;
        if (off && r.checked) r.checked = false;
      });
    }
    function chosenWindow() { var r = radios.filter(function (x) { return x.checked; })[0]; return r ? r.value : ''; }
    function commit() {
      refreshWindows();
      var d = dateEl.value, w = chosenWindow();
      if (d && (d < dateEl.min || d > dateEl.max)) { say('Please choose a date from ' + pretty(dateEl.min) + '.', true); return; }
      if (areas.length && !area()) { say('Choose a delivery area first.', true); return; }
      if (!d || !w) { say(d && !w ? 'Now choose a time.' : ''); if (ready() && (!d || !w)) save(d, w); return; }
      say('Saving…');
      save(d, w).then(syncFee).then(refreshCartView).then(function () { root.classList.remove('is-missing'); say('Delivering ' + pretty(d) + ', ' + w + '.'); summarise(); document.querySelectorAll('[data-ndw]').forEach(function (o) { if (o !== root) sync(o); }); })
        .catch(function () { say('We could not save that just now. Please try again.', true); });
    }
    var rem = root.querySelector('[data-ndw-remind]');
    if (rem) {
      try { rem.checked = localStorage.getItem(KEY + '-remind') === '1'; } catch (e) {}
      rem.addEventListener('change', function () { try { localStorage.setItem(KEY + '-remind', rem.checked ? '1' : '0'); } catch (e) {} if (dateEl.value && chosenWindow()) commit(); else if (attrs) { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Remind me next year': rem.checked ? 'Yes' : '' } }) }); } });
    }
    areas.forEach(function (a) { a.addEventListener('change', function () { setMin(); commit(); }); });
    dateEl.addEventListener('change', commit);
    radios.forEach(function (r) { r.addEventListener('change', commit); });
    root.__ndwFill = function (iso, win) {
      if (attrs && attrs['Delivery area']) areas.forEach(function (a) { a.checked = a.value === attrs['Delivery area']; });
      setMin();
      if (iso) dateEl.value = iso; refreshWindows();
      radios.forEach(function (r) { r.checked = (r.value === win) && !r.disabled; });
      if (iso && win) say('Delivering ' + pretty(iso) + ', ' + win + '.');
      summarise();
    };
    loadCart().then(function () {
      var iso = attrs['Delivery date (sortable)'], win = attrs['Delivery window'];
      if (!iso) { try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); if (s) { iso = s.date; win = s.win; } } catch (e) {} }
      if (iso && iso >= dateEl.min) root.__ndwFill(iso, win);
      if (iso && win && iso >= dateEl.min && !ready()) save(iso, win);
      if (/^\/cart/.test(location.pathname)) syncFee().then(refreshCartView);
    });
  }
  function sync(root) { if (root.__ndwFill && attrs) root.__ndwFill(attrs['Delivery date (sortable)'], attrs['Delivery window']); }

  /* hold back checkout until a date and time are set */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], button[form][name="checkout"]');
    if (!t || attrs === null) return;
    if (ready()) {
      if (!t.__feeOk && document.querySelector('[data-ndw-areas]')) { e.preventDefault(); e.stopPropagation(); syncFee().then(function () { t.__feeOk = true; if (t.href) location.href = t.href; else if (t.form) t.form.submit(); else t.click(); }); }
      return;
    }
    e.preventDefault(); e.stopPropagation();
    var box = document.querySelector('[data-ndw]');
    if (box) {
      box.classList.add('is-missing'); if (box.__ndwOpen) box.__ndwOpen(); if (box.__ndwSum) box.__ndwSum();
      var st = box.querySelector('[data-ndw-status]'); st.textContent = 'Choose a delivery date and time to continue.'; st.classList.add('is-error');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else { window.location.href = '/cart'; }
  }, true);

  function boot() { document.querySelectorAll('[data-ndw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  /* the cart re-renders itself; pick up any new picker that appears */
  new MutationObserver(function () { boot(); }).observe(document.documentElement, { childList: true, subtree: true });
  loadCart();
})();
